import { h } from 'preact'
import PropTypes from 'prop-types'

export const CloseIcon = ({ color = '#4C4C4C', dataTestId }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className="close-icon"
    data-testid={dataTestId}
  >
    <defs>
      <path
        d="m14.128 12 6.445-6.445c.57-.57.57-1.528 0-2.128-.57-.57-1.529-.57-2.128 0L12 9.872 5.555 3.457c-.57-.57-1.528-.57-2.128 0-.57.57-.57 1.529 0 2.128L9.872 12l-6.415 6.445c-.57.57-.57 1.528 0 2.128.57.57 1.529.57 2.128 0L12 14.128l6.445 6.445c.57.57 1.528.57 2.128 0 .57-.57.57-1.529 0-2.128L14.128 12z"
        id="close-icon-a"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="close-icon-b" fill="#fff">
        <use xlinkHref="#close-icon-a" />
      </mask>
      <use fill="#092A5E" fillRule="nonzero" xlinkHref="#close-icon-a" />
      <g mask="url(#close-icon-b)" fill={color}>
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>
)

CloseIcon.propTypes = {
  color: PropTypes.string,
  dataTestId: PropTypes.string,
}
